<div class="flex-container">
  <div class="flex-item">
    <h3 class="margin-top-0">{{ 'orderBusinessReportCriteria.reportCriteria' | transloco }}</h3>
    @if (order.businessReportCriteria?.businessName) {
      <div class="flex-container">
        <span class="flex-item">{{ 'common.labels.businessName2' | transloco }}</span>
        <span class="flex-item-2">{{ order.businessReportCriteria?.businessName }}</span>
      </div>
    }
    @if (order.businessReportCriteria?.number) {
      <div class="flex-container">
        <span class="flex-item">{{ 'common.labels.number2' | transloco }}</span>
        <span class="flex-item-2">{{ order.businessReportCriteria?.number }}</span>
      </div>
    }
    @if (order.businessReportCriteria?.address) {
      <div class="flex-container">
        <span class="flex-item">{{ 'orderBusinessReportCriteria.address' | transloco }}</span>
        <span class="flex-item-2">{{ order.businessReportCriteria?.address }}</span>
      </div>
    }
  </div>
</div>